module.exports = __webpack_public_path__ + "static/17-7b8d1493a2534dab08546be238866d9a.jpg";